import { getDocumentDownloadUrl } from '@myrentalmate/api-client';
import { useState } from 'react';

import { okData } from '../../lib/apiData';
import { apiErrorMessage } from '../../lib/apiError';

export function useDownloadDocument() {
  const [downloadError, setDownloadError] = useState<string | null>(null);

  async function fetchAndGo(documentId: number) {
    setDownloadError(null);
    try {
      const link = okData(await getDocumentDownloadUrl(documentId));
      if (link) window.location.assign(link.url);
    } catch (e) {
      setDownloadError(apiErrorMessage(e));
    }
  }

  return { download: (documentId: number) => void fetchAndGo(documentId), downloadError };
}
